import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { selectLanguage } from '../../redux/language/selector'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import { useSelector } from 'react-redux'
import trade_finance_documents_img1 from "../../assets/images/contents/trade-finance-document-1.png"
import trade_finance_documents_img2 from "../../assets/images/contents/trade-finance-document-2.png"
import { PrimaryButton } from '../../components/StyledButtons'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const TradeFinanceDocuments = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='trade-finance-documents bg-primary'>
            <div className='color-filter-right' style={{ top: "20%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "52%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid trade-finance-documents-header pb-100'>
                <div className='container'>

                    {language === "en" ?
                        <div className='col-sm-12 pt-150'>
                            <div className='font-weight-bold text-center font-64 trade-finance-documents-header-title'>TRADE FINANCE DOCUMENTS</div>
                            <div className='col-sm-12'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                        :
                        <div className='col-sm-10 col-sm-offset-1 pt-150'>
                            <div className='font-weight-bold text-center font-64 trade-finance-documents-header-title'>TÀI LIỆU TÀI TRỢ THƯƠNG MẠI</div>
                            <div className='col-sm-12'>
                                <div className='underline-orange'></div>
                            </div>
                        </div>
                    }
                    <div className='col-sm-12 flex justify-center pt-50 px-0'>
                        <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.trade-finance-documents')} linkToPrevPage="/industries" />
                    </div>
                </div>


            </div>
            <div className='trade-finance-documents-content container'>
                <div className='row flex-lg'>
                    <div className='col-lg-w-400'>
                        <IndustriesStickyMenu bankingAndFinancialActive={true} tradeFinancialDocumentsActive={true} />
                    </div>
                    <div className='col-lg-w--400 trade-finance-documents-content_info'>
                        <p className='font-48 font-weight-semibold text-white'>{t('trade-finance-documents.title')}</p>
                        <p className='text-white pt-20 font-weight-medium font-20'>{t('trade-finance-documents.sub-title')}</p>
                        <p className='text-white pt-20'>{t('trade-finance-documents.content-1')}</p>
                        <p className='text-white pt-20'>{t('trade-finance-documents.content-2')}</p>
                        <div className='pt-50'>
                            <img src={trade_finance_documents_img1} alt="" className='img-responsive' />
                        </div>
                        <p className='pt-50 text-white'>{t('trade-finance-documents.content-3')}</p>
                        <p className='pt-20 text-white'>{t('trade-finance-documents.content-4')}</p>
                        <div className='pt-50'>
                            <img src={trade_finance_documents_img2} alt="" className='img-responsive' />
                        </div>
                        <div className='col-sm-12 pt-30 px-0'>
                            <p className='text-white font-weight-medium'>{t('trade-finance-documents.content-5')}</p>
                            <ul className='list-unstyled pt-20'>
                                <li className='checked-line'>{t('trade-finance-documents.content-5-1')}</li>
                                <li className='checked-line'>{t('trade-finance-documents.content-5-2')}</li>
                                <li className='checked-line'>{t('trade-finance-documents.content-5-3')}</li>
                                <li className='checked-line'>{t('trade-finance-documents.content-5-4')}</li>
                                <li className='checked-line'>{t('trade-finance-documents.content-5-5')}</li>
                            </ul>
                        </div>
                        <div className='col-sm-12 pt-30'>
                            <div className='row'>
                                <PrimaryButton
                                onClick={() => setModalDiscussionOpen(true)}
                                >{t('button.schedule-discussion')}</PrimaryButton>
                            </div>
                        </div>
                    </div>
                </div>
                <IndustriesImageContainer />
            </div>

            <Footer />
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
        </div>
    )
}

export default TradeFinanceDocuments